import React from 'react';
import PlayerIdentity from '../../shared/PlayerIdentity';
import WWIcon from '../../shared/assets/WW.png';

const ContractListPlayerRow = ({ player }) => {
    const marketValue = Number(player.auction_value);
    const hasMarketValue = player.auction_value != null
      && Number.isFinite(marketValue);
    const salary = Number(player.salary);
    const surplus = hasMarketValue && Number.isFinite(salary)
      ? marketValue - salary
      : null;

    return (
      <tr>
        <td className="name-td">
            <PlayerIdentity
                player={player}
                icon={player.player_added ? WWIcon : undefined}
            />
        </td>
        <td>{player.contract_length}</td>
        <td>{player.salary}</td>
        <td>{hasMarketValue ? Math.round(marketValue) : '—'}</td>
        <td>{surplus == null ? '—' : Math.round(surplus)}</td>
        <td>
          <img src={player.team_logo_url} alt={`${player.player_name} team logo`} className="team-logo" />
        </td>

      </tr>
    );
};

export default ContractListPlayerRow;
